<template>
  <div>
    <span class="body--text">Previous Total</span><b class="float-right">£{{previousTotal.toFixed(2)}}</b><br>
    <span class="body--text">Total price exc. VAT</span><b class="float-right">£{{totalExVAT.toFixed(2)}}</b><br>
    <span class="body--text">{{tariffOrPromo.name}}</span><b class="float-right">£{{tariffOrPromo.price.toFixed(2)}}</b><br>
    <span class="body--text">VAT</span><b class="float-right">£{{vat.toFixed(2)}}</b><br>
    <span class="body--text">Total price</span><b class="float-right">£{{total.toFixed(2)}}</b><br>
    <span class="body--text">Ad Hoc Charges excl. VAT</span><b class="float-right">£{{this.calculateRequiredCharges().toFixed(2)}}</b><br>
  </div>
</template>

<script>
  export default {
    props: ['formData','adhoc'],
    methods: {
      promoOrTariff(tariff,promo) {
        let ret = {name:'nothing selected',price:0};
        if(tariff.id!==''){ ret = {name:'Tariff',price:tariff.price}; }
        if(promo.id!==''){ ret = {name:'Promo',price:promo.price}; }
        return ret;
      },
      siteAddonIsQuantity(allow_quantity,quantity,selected,price){
        if(allow_quantity){
          return (quantity * price);
        }else{
          if(selected){
            return price;
          }
          return 0;
        }
      },
      calculateSiteAddons(addons,type) {
        let total = 0;
        Object.keys(addons).forEach(addon_key => {
          let add = addons[addon_key];
          if(type==='initial'){
            total += this.siteAddonIsQuantity(add.allow_quantity,add.iniQuantity,add.iniSelected,add.price);
          }else if(type==='current'){
            total += this.siteAddonIsQuantity(add.allow_quantity,add.quantity,add.selected,add.price);
          }
        });
        return total;
      },
      calculateUserAddons(users,type) {
        let total = 0;
        users.forEach(user => {
          Object.keys(user.addons).forEach(k => {
            let group = user.addons[k];
            if(group.count>1){
              if(type==='initial'){
                total += (group.iniSelected!==false)?group.iniPrice:0;
              }else if(type==='current'){
                total += (group.selected!==false)?group.price:0;
              }
            }else{
              group.items.forEach(add => {
                if(type==='initial'){
                  total += (add.iniSelected)?add.price:0;
                }else if(type==='current'){
                  total += (add.selected)?add.price:0;
                }
              });
            }
          });
        });
        return total;
      },
      calculateRequiredCharges() {
        let total = 0;
        this.adhoc.forEach(e => {
          total += e.price * e.quantity;
        });
        return total;
      },
      calculateVAT(total){
        return total * 1.14;
      },
    },
    computed: {
      previousTotal() {
        let fd = this.formData;
        let total = this.promoOrTariff(fd.iniTariff,fd.iniPromo).price;
        total += this.calculateSiteAddons(fd.siteAddons,'initial');
        total += this.calculateUserAddons(fd.users,'initial');
        total = this.calculateVAT(total);
        return total;
      },
      totalExVAT() {
        let fd = this.formData;
        let total = this.promoOrTariff(fd.tariff,fd.promo).price;
        total += this.calculateSiteAddons(fd.siteAddons,'current');
        total += this.calculateUserAddons(fd.users,'current');
        return total;
      },
      tariffOrPromo() {
        let fd = this.formData;
        return this.promoOrTariff(fd.tariff,fd.promo);
      },
      vat() {
        return this.totalExVAT * 0.14;
      },
      total() {
        return this.calculateVAT(this.totalExVAT);
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
